<div class="section-container">
  <h1>{{description}}</h1>
  <div class="section-content">
    <ng-content></ng-content>
  </div>
</div>
